import { ReduxService } from 'dashboard-services/services';

import { tableCustomInsightActions } from 'actions/modules/insight';

const emptyColumn = {
  columnId: undefined,
  columnWidth: undefined,
  unitOnFront: false,
  unit: undefined,
  textStyle: undefined,
  textColor: undefined,
  textAlign: undefined,
  bgColor: undefined,
  fontSize: undefined
}

const emptyConditionalFormatting = {
  textStyle: undefined,
  textColor: undefined,
  textAlign: undefined,
  bgColor: undefined,
  fontSize: undefined,
  applyTo: undefined,
  condition: undefined,
  conditionValueA: undefined,
  conditionValueB: undefined
}

export const tableCustomReducer = (state, action) => {
  switch (action.type) {
    case tableCustomInsightActions.ADD_COLUMN: 
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({ 
            columns: state.content.tiles[action.index].columns.add(Object.assign({}, emptyColumn, action.value || {}))
          }, action.index),
        })
      })
    case tableCustomInsightActions.REMOVE_COLUMN:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            columns: state.content.tiles[action.tileIndex].columns.remove(action.columnIndex)
          }, action.tileIndex)
        })
      })
    case tableCustomInsightActions.CHANGE_COLUMN_IN_TABLE:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({
            columns: state.content.tiles[action.tileIndex].columns.updateInList({
              [action.name]: action.value
            }, action.columnIndex)
          }, action.tileIndex)
        })
      })
    case tableCustomInsightActions.ADD_CONDITIONAL_FORMATTING: 
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({ 
            conditionalFormatting: (state.content.tiles[action.index].conditionalFormatting || []).add(Object.assign({}, emptyConditionalFormatting, action.value || {}))
          }, action.index),
        })
      })
    case tableCustomInsightActions.COPY_CONDITIONAL_FORMATTING: 
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({ 
            conditionalFormatting: (state.content.tiles[action.tileIndex].conditionalFormatting || []).add(Object.assign({}, state.content.tiles[action.tileIndex].conditionalFormatting[action.copyIndex]), action.copyIndex + 1)
          }, action.tileIndex),
        })
      })
    case tableCustomInsightActions.REMOVE_CONDITIONAL_FORMATTING:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            conditionalFormatting: state.content.tiles[action.tileIndex].conditionalFormatting.remove(action.conditionalFormattingIndex),
          }, action.tileIndex)
        })
      })
    case tableCustomInsightActions.CHANGE_CONDITIONAL_FORMATTING: {
      if(state.content.tiles[action.tileIndex]?.conditionalFormatting?.[action.conditionalFormattingIndex]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, {
            tiles: state.content.tiles.updateInList({
              conditionalFormatting: state.content.tiles[action.tileIndex].conditionalFormatting.updateInList({
                [action.name]: action.value
              }, action.conditionalFormattingIndex)
            }, action.tileIndex)
          })
        })
      }
      return state;
    }
    case tableCustomInsightActions.ADD_CURVE:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({
            source: ReduxService.updateObject(state.content.tiles[action.tileIndex].source, {
                value: ReduxService.updateObject(state.content.tiles[action.tileIndex].source.value, {
                  curves: state.content.tiles[action.tileIndex].source.value.curves.add(action.value)
                })
              })
            }, action.tileIndex)
          })
        })
    case tableCustomInsightActions.COPY_CURVE:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({
            source: ReduxService.updateObject(state.content.tiles[action.tileIndex].source, {
                value: ReduxService.updateObject(state.content.tiles[action.tileIndex].source.value, {
                  curves: state.content.tiles[action.tileIndex].source.value.curves.add(Object.assign({}, state.content.tiles[action.tileIndex].source.value.curves[action.copyIndex]), action.copyIndex + 1)
                })
              })
            }, action.tileIndex)
          })
        })
    case tableCustomInsightActions.REMOVE_CURVE:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({
            source: ReduxService.updateObject(state.content.tiles[action.tileIndex].source, {
                value: ReduxService.updateObject(state.content.tiles[action.tileIndex].source.value, {
                  curves: state.content.tiles[action.tileIndex].source.value.curves.remove(action.curveIndex)
                })
              })
            }, action.tileIndex)
          })
        })
    case tableCustomInsightActions.ON_CHANGE_CURVE:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({
            source: ReduxService.updateObject(state.content.tiles[action.tileIndex].source, {
                value: ReduxService.updateObject(state.content.tiles[action.tileIndex].source.value, {
                  curves: state.content.tiles[action.tileIndex].source.value.curves.updateInList({
                    [action.name]: action.value
                  }, action.curveIndex)
                })
              })
            }, action.tileIndex)
          })
        })
    case tableCustomInsightActions.ON_REORDER_CURVE:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({
            source: ReduxService.updateObject(state.content.tiles[action.tileIndex].source, {
                value: ReduxService.updateObject(state.content.tiles[action.tileIndex].source.value, {
                  curves: state.content.tiles[action.tileIndex].source.value.curves.moveItem(action.from, action.to)
                })
              })
            }, action.tileIndex)
          })
        })
    case tableCustomInsightActions.ADD_ADVANCED_SORTING_COLUMN:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({ 
            advancedSortingConfig: (state.content.tiles[action.index]?.advancedSortingConfig || []).add(ReduxService.updateObject(tableCustomInsightActions.GET_EMPTY_ADVANCED_SORTING_COLUMN(), action.value))
          }, action.index),
        })
      })
    case tableCustomInsightActions.REMOVE_ADVANCED_SORTING_COLUMN:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            advancedSortingConfig: state.content.tiles[action.tileIndex]?.advancedSortingConfig?.remove(action.advancedSortingColumnIndex),
          }, action.tileIndex)
        })
      })
    case tableCustomInsightActions.CHANGE_ADVANCED_SORTING_COLUMN: {
      if(state.content.tiles[action.tileIndex].advancedSortingConfig[action.advancedSortingColumnIndex]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, {
            tiles: state.content.tiles.updateInList({
              advancedSortingConfig: state.content.tiles[action.tileIndex].advancedSortingConfig?.updateInList({
                [action.name]: action.value
              }, action.advancedSortingColumnIndex)
            }, action.tileIndex)
          })
        })
      }
      return state;
    }
    case tableCustomInsightActions.ADD_CONTEXT_MENU_ITEM:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({ 
            contextMenuActions: (state.content.tiles[action.index]?.contextMenuActions || []).add(ReduxService.updateObject(tableCustomInsightActions.EMPTY_CUSTOM_CONTEXT_MENU_ITEM, { 
              id: action.menuOptionId,
            })),
          }, action.index),
        })
      })
    case tableCustomInsightActions.REMOVE_CONTEXT_MENU_ITEM:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            contextMenuActions: state.content.tiles[action.tileIndex]?.contextMenuActions?.remove(action.contextMenuIndex),
          }, action.tileIndex)
        })
      })
    case tableCustomInsightActions.CHANGE_CONTEXT_MENU_ITEM:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({
            contextMenuActions: state.content.tiles[action.tileIndex].contextMenuActions?.updateInList({
              [action.name]: action.value
            }, action.contextMenuIndex)
          }, action.tileIndex)
        })
      })
    case tableCustomInsightActions.CHANGE_ROW_CONFIG_IN_TABLE: {
      if(state.content.tiles[action.tileIndex]?.rowConfigs?.[action.rowConfigIndex]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, {
            tiles: state.content.tiles.updateInList({
              rowConfigs: state.content.tiles[action.tileIndex].rowConfigs.updateInList({
                [action.name]: action.value
              }, action.rowConfigIndex)
            }, action.tileIndex)
          })
        })
      }
      return state;
    }
    default:
      return undefined;
  }
}